var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-view",class:{
    menuIsOpen: _vm.menuIsOpen && !_vm.hideMenu,
    menuHide: _vm.hideMenu,
    dark: _vm.darkEnabled,
    popupIsOpen: _vm.popupIsOpen,
    modifyPadding: _vm.modifyPadding
  },style:(_vm.contentStyle)},[_c('Header'),_c('div',{class:_vm.modifyPadding ? 'container-page-academy' : 'container-page'},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"child-view view-parent"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }